// Mirror of the API's normalize-plan-handle.js: sellers keep `grow` until
// the Grow merge migration has run. Delete this file, and its call site in
// AuthContext.js, with the follow-up PR.
export default function normalizeSellerPlan(plan) {
  if (plan?.handle !== 'grow') return plan;

  return { ...plan, handle: 'scale', bracket: 10000 };
}
